import React from 'react';
import { graphql } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import SEO from '../../components/SEO';
import Layout from '../../components/Layout';

const Team = (props) => {
  const { locale } = props.pageContext;
  const teams = props.data.allMarkdownRemark.edges;
  return (
    <Layout bodyClass="page-teams" locale={locale}>
      <SEO title="Team"/>
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>
                Meet The
                <FormattedMessage id="Team"/>
              </h1>
              <p>
                Our team of qualified accountants and financial consultants can help your business
                at any stage of it’s growth.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container pb-6">
        <div className="row">
          {teams.map(edge => (
            <div key={edge.node.frontmatter.path} className="col-12 col-md-6 mb-1">
              <div className="team card-two">
                <div className="card-header">
                  <div className="card-header-left">
                    {edge.node.frontmatter.image && (
                      <div className="card-image">
                        <img
                          alt={edge.node.frontmatter.title}
                          className="img-fluid mb-2"
                          src={edge.node.frontmatter.image}
                        />
                      </div>
                    )}
                  </div>
                  <div className="card-right">
                    <h2 className="card-title">{edge.node.frontmatter.title}</h2>
                    <ul className="card-meta">
                      <li>
                        <strong>{edge.node.frontmatter.jobtitle}</strong>
                      </li>
                      <li>
                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                        <a target="_blank" href={edge.node.frontmatter.linkedinurl}>
                          {edge.node.frontmatter.linkedinurl}
                        </a>
                      </li>
                      <li>
                        <a href={edge.node.frontmatter.email}>{edge.node.frontmatter.email}</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="team-content"
                  dangerouslySetInnerHTML={{ __html: edge.node.html }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
    query TeamQuery {
        allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/team/" } }
            sort: { fields: [frontmatter___date], order: DESC }
        ) {
            edges {
                node {
                    html
                    frontmatter {
                        title
                        path
                        image
                        jobtitle
                        linkedinurl
                        email
                    }
                }
            }
        }
    }
`;

export default Team;
